import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Button, Menu, MenuItem, Typography } from "@mui/material";
import React, { useContext, useState } from "react";


import DataContext from "../../../../../context/DataContext";
import Modal from "../../../../global/Modal";
import WarningModal from "../../../../ui library/components/base-modal/types/WarningModal";
import HNSColors from "../../../../ui library/HNSColors";

const DocumentActions = ({
  document,
  handleOpenAssociateAppointmentModal,
  setIsLaunchedFromAppointmentsTab,
}) => {
  const { userRoles } = useContext(DataContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showWarningModal, setShowWarningModal] = useState(false);

  const canViewAssociatedDocuments = userRoles.permissions.includes(
    "filemanager.view_document_association"
  );

  const hasRelatedProvider = document?.providerName || document?.provider;

  const hasAppointments = document?.providerTotalAppointmentCount > 0;

  const handleClickActionMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseActionMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectAction = (action) => {
    handleCloseActionMenu();
    if (action === "associateDocuments") {
      if (!hasAppointments) {
        setShowWarningModal(true);
        return;
      }
      setIsLaunchedFromAppointmentsTab(false);
      handleOpenAssociateAppointmentModal(document, true);
    }
  };

  const handleCloseWarningModal = () => {
    setShowWarningModal(false);
  };

  if (!canViewAssociatedDocuments) {
    return null;
  }

  const showAssociateDocuments = hasRelatedProvider;

  if (!showAssociateDocuments) {
    return null;
  }

  return (
    <div className="mr-4 flex items-center">
      <Button
        className="text-sm capitalize"
        id="action-button"
        aria-controls={anchorEl ? "action-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={!!anchorEl || undefined}
        onClick={handleClickActionMenu}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          "& .MuiButton-endIcon > .MuiSvgIcon-root": {
            fontSize: "1.8rem",
          },
          color: HNSColors.primary[500],
        }}
      >
        Actions
      </Button>
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleCloseActionMenu}
        MenuListProps={{
          "aria-labelledby": "action-button",
        }}
      >
        {showAssociateDocuments && (
          <MenuItem
            className="text-sm"
            onClick={() => {
              handleSelectAction("associateDocuments");
            }}
          >
            Associate Documents
          </MenuItem>
        )}
      </Menu>
      <Modal open={showWarningModal} onClose={handleCloseWarningModal}>
        <WarningModal
          buttons={[
            {
              label: "OK",
              type: "OK",
              onClick: handleCloseWarningModal,
            },
          ]}
          title="Warning"
          message={
            <Typography>
              No Appointments Exist Between the Client and the Provider. Please create the
              appointment before continuing.
            </Typography>
          }
        />
      </Modal>
    </div>
  );
};

export default DocumentActions;
